import { Navigate, Route, Routes } from 'react-router-dom'
import './App.css'
import LambdaDashBoard from './pages/LambdaMonitor/LambdaDashBoard'
import Dashboard from './pages/Dashboard/Dashboard'
import LogsPage from './pages/Logs/LogsPage'
import SettingsPage from './pages/Settings/SettingsPage'
import ComingSoon from './components/comingSoon/ComingSoonPage'

function App() {
  return (
    <>

     <Routes>
       <Route path="/" element={<Navigate to="/san-env" replace />} />
      <Route  path="/san-env" element={
      <LambdaDashBoard />
      } />

      <Route  path="/san-env" element={
      <LambdaDashBoard />
      } />

       <Route  path="/san-prod-env" element={
      <LambdaDashBoard />
      } />
      {/* <Route path="/cobl-env" element={
      <LambdaDashBoard />
      } />
      <Route path="/demo-env" element={
      <LambdaDashBoard />
      } />

       <Route path="/hcinternal-env" element={
      <LambdaDashBoard />
      } /> */}
      

       {/* <Route path="/test-env" element={
      <LambdaDashBoard />
      } /> */}
     
      <Route path="/dashboard" element={
      <Dashboard />

      } />

       <Route path="/logs" element={
      <LogsPage />

      } />

       <Route path="/settings" element={
      <SettingsPage />

      } />

      <Route path="*" element={<ComingSoon/>}/>
    </Routes>
    </>
  )
}

export default App
